import { useStorage } from 'frontend/utils/hooks/useStorage';
import ExternalLink from 'icons/external-link.svg';
import Lock from 'icons/lock.svg';
import UnLock from 'icons/unlock.svg';
import SpaLink from 'components/SpaLink/SpaLink';
import styles from './LinkList.module.css';
import { PARENTAL_LOCK_LOCAL_STORAGE_KEY } from 'components/ParentalLock/ParentalLock';
const ListItem = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <li className={styles.linkListItem} data-sentry-component="ListItem" data-sentry-source-file="LinkList.tsx">{children}</li>;
};
const LinkList = () => {
  const {
    storageValue
  } = useStorage(PARENTAL_LOCK_LOCAL_STORAGE_KEY);
  const isParentalLockActive = Boolean(storageValue);
  return <>
      <ul>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <a href="https://www.ur.se/om-oss/sa-arbetar-ur" target="_blank" rel="noopener" className={styles.link}>
            Så arbetar UR
            <ExternalLink className={styles.externalIcon} role="img" aria-label="Öppnas i nytt fönster" data-sentry-element="ExternalLink" data-sentry-source-file="LinkList.tsx" />
          </a>
        </ListItem>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <SpaLink href="/barnlas" className={styles.link} data-sentry-element="SpaLink" data-sentry-source-file="LinkList.tsx">
            Barnlås
            {isParentalLockActive ? <Lock aria-hidden data-testid="active-lock" className={styles.lockIcon} focusable="false" /> : <UnLock aria-hidden data-testid="inactive-lock" className={styles.lockIcon} focusable="false" />}
          </SpaLink>
        </ListItem>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <a href="https://www.ur.se/tillganglighetsredogorelse" target="_blank" rel="noopener" className={styles.link}>
            Tillgänglighetsredogörelse
            <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="LinkList.tsx" />
          </a>
        </ListItem>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <a href="https://www.ur.se/nyhetsbrev" target="_blank" rel="noopener" className={styles.link}>
            Nyhetsbrev
            <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="LinkList.tsx" />
          </a>
        </ListItem>
      </ul>
      <ul>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <a href="https://www.ur.se" target="_blank" rel="noopener" className={styles.link}>
            UR.se
            <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="LinkList.tsx" />
          </a>
        </ListItem>
        <ListItem data-sentry-element="ListItem" data-sentry-source-file="LinkList.tsx">
          <a href="https://www.ur.se/vart-utbud/ur-access" target="_blank" rel="noopener" className={styles.link}>
            Access och mediecentraler
            <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="LinkList.tsx" />
          </a>
        </ListItem>
      </ul>
    </>;
};
export default LinkList;